export const formatLocale = (lang: string) => {
  if (lang === "en") return "en";

  const parts = lang.split("-");

  return `${parts[0]}-${parts[1].toUpperCase()}`;
};
